module.exports = __webpack_public_path__ + "static/media/cross.9dc57807.svg";